module.exports = __webpack_public_path__ + "static/media/IMG-1.fa2bd124.jpg";